// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1pYsL","header":"ReportDetails_header__3H8x4","title":"ReportDetails_title__1rJjZ","left":"ReportDetails_left__3GN0H"};